import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IMachineOverviewBlockData } from './IMachineOverviewBlockData';

export const DynamicMachineOverviewBlock = dynamic<
    BlockProps<IMachineOverviewBlockData>
>(() => import('./MachineOverviewBlock').then(md => md.MachineOverviewBlock));
